import { Star } from "lucide-react";

const items = [
  {
    quote:
      "Centralizamos WhatsApp, IG y web chat en una sola bandeja. Pasamos de tardar horas a responder en minutos. La diferencia se nota en ventas el mismo mes.",
    name: "Director Comercial",
    role: "Empresa SaaS · LATAM",
  },
  {
    quote:
      "David no solo te entrega estrategia: implementa, conecta el CRM y deja al equipo entrenado. Nunca había trabajado con un consultor que también opere.",
    name: "CEO",
    role: "Educación corporativa",
  },
  {
    quote:
      "El sistema de Daos Ads cierra ventas mientras dormimos. Subimos el ROAS en Meta y bajamos costo por lead calificado en menos de 60 días.",
    name: "Head of Growth",
    role: "Servicios B2B",
  },
  {
    quote:
      "Implementación quirúrgica de Respond.io. Reportes claros, automatizaciones que sí funcionan y cero leads perdidos en festivos.",
    name: "Gerente de Marketing",
    role: "Retail mediano",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-24 sm:py-32">
      <div className="container-x">
        <div className="max-w-2xl reveal">
          <div className="eyebrow mb-5">Lo que dicen</div>
          <h2 className="font-display font-extrabold text-white text-4xl sm:text-5xl tracking-tighter leading-[1.05]">
            Clientes que dejaron de <span className="text-gradient">perder leads</span>.
          </h2>
          <p className="mt-3 text-zinc-500 text-sm">* Testimonios genéricos por confidencialidad. Nombres reales disponibles bajo solicitud.</p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-5">
          {items.map((t, i) => (
            <div key={i} className="reveal grad-border p-8 card-lift" style={{ transitionDelay: `${i * 70}ms` }}>
              <div className="flex gap-0.5 text-[#ffd23f] mb-4">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star key={k} className="w-4 h-4 fill-current" />
                ))}
              </div>
              <p className="text-zinc-200 text-lg leading-relaxed">"{t.quote}"</p>
              <div className="mt-6 flex items-center gap-3 pt-5 border-t border-white/10">
                <div className="w-10 h-10 rounded-full bg-gradient-brand grid place-items-center text-black font-display font-bold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="text-white font-display font-semibold text-sm">{t.name}</div>
                  <div className="text-zinc-500 text-xs">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
